import { opensPalette } from "./command-palette.keys.js";

/**
 * The ⌘K palette's entry-chunk half. The palette (`command-palette.ts`) and its model reach board
 * code (`view-controls.model.ts`), so the homepage must not load them at startup
 * (`routes.split.test.ts`). The entry holds only this: the first ⌘K or a click on the masthead's
 * theme icon imports the palette, installs it site-wide and opens it. The watch page, a lazy chunk
 * already, imports the palette statically and mounts its own commands.
 */
let loading: Promise<typeof import("./command-palette.js")> | null = null;

function openLoaded(submenuId?: string): void {
  loading ??= import("./command-palette.js");
  void loading.then((palette) => {
    palette.installCommandPalette();
    palette.openCommandPalette(submenuId);
  });
}

/** Listen for the first ⌘K; from then on the installed palette owns the key. */
export function installCommandPalette(): void {
  const onKey = (event: KeyboardEvent): void => {
    if (!opensPalette(event)) return;
    event.preventDefault();
    document.removeEventListener("keydown", onKey);
    openLoaded();
  };
  document.addEventListener("keydown", onKey);
}

/** Open the palette, straight into a submenu by id ("theme"): the masthead's icon. */
export function openCommandPalette(submenuId?: string): void {
  openLoaded(submenuId);
}
